import Vue from "vue";

const state = {
  userPhones: [],
  total: 0
};

const getters = {};

const actions = {
  LOAD_USER_PHONES: async function({ commit }, payload) {
    Vue.prototype.$axios
      .get(
        "users/" +
          payload.userId +
          "/phones?from=" +
          payload.from +
          "&limit=" +
          payload.to
      )
      .then(res => {
        commit("SET_USER_PHONES", res.data.userPhones);
        commit("SET_TOTAL", res.data.meta.total);
      });
  },
  CREATE_USER_PHONE: async function({ commit }, payload) {
    await Vue.prototype.$axios
      .post("/users/" + payload.userId + "/phones", payload.phone)
      .then(
        res => {},
        err => {
          throw new Error(err);
        }
      );
  },
  UPDATE_USER_PHONE: async function({ commit }, payload) {
    await Vue.prototype.$axios
      .post(
        "/users/" + payload.userId + "/phones/" + payload.phone.id,
        payload.phone
      )
      .then(
        res => {},
        err => {
          throw new Error(err);
        }
      );
  },
  DESTROY_USER_PHONE: async function({ commit }, payload) {
    await Vue.prototype.$axios
      .delete("/users/" + payload.userId + "/phones/" + payload.id)
      .then(
        res => {},
        err => {
          throw new Error(err);
        }
      );
  }
};

const mutations = {
  SET_USER_PHONES: function(state, payload) {
    state.userPhones = payload;
  },
  SET_TOTAL: function(state, payload) {
    state.total = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
